import type { ReactNode } from "react";
import { Skeleton } from "../../components/ui/Feedback";
import { ApiError } from "../../lib/api";
import { useSession } from "./useSession";

/**
 * What a merchant sees when they land here without a session, which is almost
 * always a bookmark or a stale tab rather than anything going wrong. It says
 * how to get back in and nothing else: session lifetime and a health endpoint
 * are our concerns, and putting them here only invites a support ticket about
 * a status page that was green all along.
 */
const SignedOut = () => (
	<div className="mx-auto flex min-h-screen max-w-sm flex-col items-center justify-center gap-3 px-6 text-center">
		<img src="/logo.svg" width="40" height="40" alt="" className="rounded-[11px]" />
		<h1 className="text-base font-semibold tracking-tight text-ink">Welcome back</h1>
		<p className="text-sm text-ink-muted">
			Open AOVtools from your Shopify admin and we will sign you straight in.
		</p>
	</div>
);

export const RequireSession = ({ children }: { children: ReactNode }) => {
	const { isPending, error } = useSession();

	if (isPending) {
		return (
			<div className="mx-auto max-w-6xl space-y-4 px-6 py-10">
				<Skeleton className="h-8 w-64" />
				<Skeleton className="h-32 w-full" />
			</div>
		);
	}

	if (error instanceof ApiError && error.isUnauthenticated) return <SignedOut />;

	return <>{children}</>;
};
